import { defaultHttpClient } from 'shared/src/api/httpClient';
import type {
  GetFolderDetailCategoriesParams,
  GetFolderDetailCategoriesResponse,
} from './types';

export const getFolderDetailCategories = async ({
  folder_sno,
}: GetFolderDetailCategoriesParams) => {
  return defaultHttpClient
    .request<GetFolderDetailCategoriesResponse>({
      method: 'GET',
      url: `/api/v2/members/me/liked_folders/${folder_sno}/categories/`,
    })
    .then(result => result.data);
};
